// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2RC_p","content":"styles_content__3fKA1","selectAll":"styles_selectAll__2t7iK"};